import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Conveyor add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminConveyorForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminConveyorFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminConveyorForm}
 *
 * @type {ngController}
 */
export class tmrAdminConveyorFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    tmrConveyorTypes,
    tmrConveyorModeTypes,
    tmrRfidReaderTypes,
    BarcodeReader,
    DeviceController,
    Place,
    RfidReader,
    User
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, {
      tmrConveyorTypes,
      tmrConveyorModeTypes,
      tmrRfidReaderTypes,
      BarcodeReader,
      DeviceController,
      Place,
      RfidReader,
      User,
    })
  }

  $onInit() {
    super.$onInit()
    if (this.op == 'add') this.resource.autostart = true
  }

  getDeviceControllers(value) {
    return this.DeviceController.search({ value, type: 'CONVEYOR_MANAGER' })
      .$promise
  }

  getPlaces(value) {
    return this.Place.search({ value }).$promise
  }

  onPlaceChange() {
    this.resource.rfidReader = null
    this.$scope.resourceForm.rfidReader.$setPristine()
  }

  getUsers(value) {
    return this.User.search({ value }).$promise
  }

  getRfidReaders(value) {
    if (this.resource.place && this.resource.place.id)
      return this.RfidReader.search({
        value,
        'place.id': this.resource.place.id,
      }).$promise
    return []
  }

  onRfidReaderChange() {
    if (this.$scope.resourceForm.rfidReader) {
      this.$scope.resourceForm.rfidReader.$setValidity('isImpinj', true) // ogni volta che cambia resetto la validità del form per fare nuovamente il controllo
      this.$scope.resourceForm.rfidReader.$setValidity('isZebra', true)
      if (
        this.resource.type == 'TmrImpinjConveyorDto' ||
        this.resource.type == 'TimedImpinjConveyorDto'
      ) {
        this.$scope.resourceForm.rfidReader.$setValidity(
          'isImpinj',
          !this.resource.rfidReader ||
            this.resource.rfidReader.type == 'ImpinjSpeedwayOctaneDto'
        )
        return
      }
      if (
        this.resource.type == 'TmrZebraConveyorDto' ||
        this.resource.type == 'TimedZebraConveyorDto'
      ) {
        this.$scope.resourceForm.rfidReader.$setValidity(
          'isZebra',
          !this.resource.rfidReader ||
            this.resource.rfidReader.type == 'ZebraReaderDto'
        )
        return
      }
    }
  }

  getBarcodeReaders(value) {
    return this.BarcodeReader.search({ value }).$promise
  }
}
